import OnScreen from 'onscreen';

const os = new OnScreen();

// do something when a loader component enters the viewport
os.on('enter', '.loader', (component) => {
    $(component).attr('data-active', true);
    // create artificial delay before the actual "loading"
    setTimeout(() => {
        $(component).trigger('click');
    }, 500);
});



// WEBPACK FOOTER //
// ./src/scripts/components/loader/index.js